/**
 * ChessPiece component
 * 
 * Displays a chess piece based on its type and color.
 */

import React from 'react';
import { PieceType, PieceColor } from '../../../types/chess';
import styles from './ChessPiece.module.css';

interface ChessPieceProps {
  type: PieceType;
  color: PieceColor;
  square?: string;
  isSelected?: boolean;
  onClick?: (square: string) => void;
}

/**
 * ChessPiece - Renders a chess piece with appropriate styling
 */
const ChessPiece: React.FC<ChessPieceProps> = ({
  type,
  color,
  square = '',
  isSelected = false,
  onClick
}) => {
  // Unicode chess pieces for each type and color
  const pieces = {
    w: {
      p: '♙', // white pawn
      n: '♘', // white knight
      b: '♗', // white bishop
      r: '♖', // white rook
      q: '♕', // white queen
      k: '♔'  // white king
    },
    b: {
      p: '♟', // black pawn
      n: '♞', // black knight
      b: '♝', // black bishop
      r: '♜', // black rook
      q: '♛', // black queen
      k: '♚'  // black king
    }
  };

  // Get the Unicode character for the piece
  const pieceChar = pieces[color][type];
  
  // Handle click event
  const handleClick = () => {
    if (onClick && square) {
      onClick(square);
    }
  };
  
  return (
    <div 
      className={`${styles.piece} ${isSelected ? styles.selected : ''} ${styles[color]}`} 
      onClick={handleClick}
      data-testid={`piece-${color}${type}${square ? `-${square}` : ''}`}
    >
      {pieceChar}
    </div>
  );
};

export default ChessPiece; 